import { Auth2FaVerificationResponse } from "../../../models/auth2FaData";

/**
 * Model for the Auth2FaVerificationState
 * @param data: Auth2FaVerificationData - The data for 2FA verification
 * @param isLoading: boolean - Indicates if the verification is in progress
 * @param isLoaded: boolean - Indicates if the verification has been completed
 * @param isError: boolean - Indicates if there was an error during verification
 */
export interface Auth2FaVerificationState {
  data: Auth2FaVerificationResponse;
  isLoading: boolean;
  isLoaded: boolean;
  isError: boolean;
}

// Action types for 2FA verification
// These are used to manage the state of the 2FA verification process in the Redux store
export const AUTH_2FA_VERIFICATION_REQUEST = "AUTH_2FA_VERIFICATION_REQUEST";
export const AUTH_2FA_VERIFICATION_FAILURE = "AUTH_2FA_VERIFICATION_FAILURE";
export const AUTH_2FA_VERIFICATION_SUCCESS = "AUTH_2FA_VERIFICATION_SUCCESS";

// Action interfaces for 2FA verification
// These interfaces define the structure of the actions dispatched during the 2FA verification process
export interface Auth2FaVerificationRequestAction {
  type: typeof AUTH_2FA_VERIFICATION_REQUEST;
}
export interface Auth2FaVerificationFailureAction {
  type: typeof AUTH_2FA_VERIFICATION_FAILURE;
}
export interface Auth2FaVerificationSuccessAction {
  type: typeof AUTH_2FA_VERIFICATION_SUCCESS;
  detail: Auth2FaVerificationResponse;
}

export type Auth2FaActionTypes =
  | Auth2FaVerificationRequestAction
  | Auth2FaVerificationFailureAction
  | Auth2FaVerificationSuccessAction;
